import React from "react";
import { Link, Route } from "react-router-dom";

import NotFound from "../components/NotFound";
import LeaguesIndex, { loader as LeaguesLoader } from "../pages/Leagues/Index";
import LeaguesLayout from "../pages/Leagues/Layout";
import League, { loader as LeagueLoader } from "../pages/Leagues/League";
import LeagueSchedule, {
    loader as ScheduleLoader,
} from "../pages/Leagues/LeagueSchedule";
import LeagueTeam, {
    loader as LeagueTeamLoader,
} from "../pages/Leagues/LeagueTeam";
import PlayoffBracket, {
    loader as PlayoffLoader,
} from "../pages/Leagues/PlayoffBracket";
import { ILeague, ILeagueSchedule, ITeamSchedule } from "../types/api";

export default (
    <Route
        path="leagues"
        handle={{
            crumb: () => "Leagues",
        }}
        element={<LeaguesLayout />}
    >
        <Route
            index
            element={<LeaguesIndex />}
            loader={LeaguesLoader}
            handle={{
                header: () => "Leagues",
            }}
        />
        <Route
            path=":leagueId"
            loader={LeagueLoader}
            handle={{
                crumb: ({ league }: { league: ILeague }) => (
                    <Link to={`/leagues/${league.id}`}>
                        {league.ageLevel}
                        {league.designation ? " " + league.designation : ""}
                        {league.direction ? " " + league.direction : ""}
                    </Link>
                ),
            }}
        >
            <Route
                index
                element={<League />}
                loader={LeagueLoader}
                handle={{
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="schedule"
                element={<LeagueSchedule />}
                loader={ScheduleLoader}
                handle={{
                    crumb: ({ schedule }: { schedule: ILeagueSchedule }) => (
                        <Link to={`/leagues/${schedule.league}/schedule`}>
                            Schedule
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="playoffs"
                element={<PlayoffBracket />}
                loader={PlayoffLoader}
                handle={{
                    crumb: (league: ILeague) => (
                        <Link to={`/leagues/${league.id}/playoffs`}>
                            Playoff Bracket
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="teams/:teamId"
                element={<LeagueTeam />}
                loader={LeagueTeamLoader}
                handle={{
                    crumb: ({ schedule }: { schedule: ITeamSchedule }) => (
                        <Link
                            to={`/leagues/${schedule.league}/teams/${schedule.teamId}`}
                        >
                            {schedule.teamName}
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="*"
                element={<NotFound parent="leagues" />}
                handle={{ header: () => "League Page Not Found" }}
            />
        </Route>
    </Route>
);
